import { TableRow, TableCell } from "@/components/ui/table";

type Props = {
  loading?: boolean;
  colSpan?: number;
};

export function EmptyOrLoading({ loading, colSpan = 12 }: Props) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        {loading ? (
          <div className="text-center text-gray-400 text-sm py-6 animate-pulse">
            Loading data...
          </div>
        ) : (
          <div className="text-center text-gray-400 text-sm py-6">
            No data.
          </div>
        )}
      </TableCell>
    </TableRow>
  );
}
